import React, { useCallback } from 'react';
import Nouislider from 'nouislider-react';
import 'nouislider/distribute/nouislider.css';
import '../styles/App.css';

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const RangeSlider = ({ start, end, duration = 0, currentTime, onTimeChange, onStartChange, onEndChange, isDisabled }) => {
  const handleUpdate = useCallback(
    debounce((values, handle) => {
      if (isDisabled) return;
      const [newStart, newCurrentTime, newEnd] = values.map(parseFloat);
      if (handle === 0) {
        onStartChange(newStart);
        if (newStart > currentTime) {
          onTimeChange(newStart);
        }
      } else if (handle === 1) {
        onTimeChange(newCurrentTime);
      } else if (handle === 2) {
        onEndChange(newEnd);
      }
    }, 100),
    [currentTime, onStartChange, onTimeChange, onEndChange]
  );

  return (
    <div className="range-slider">
      <Nouislider
        range={{ min: 0, max: duration }}
        start={[start, currentTime, end]}
        connect={[false, true, true, false]}
        onUpdate={handleUpdate}
      />
      <div className="range-values">
        <span>Start: {start.toFixed(2)}</span>
        <span>Current Time: {currentTime.toFixed(2)}</span>
        <span>End: {end.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default RangeSlider;